import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

import { generateIconComponent } from './helpers';

export const ChevronDown = generateIconComponent(faChevronDown);
